import { motion } from 'framer-motion'
import { useLanguage } from '../contexts/LanguageContext'
import { useMemo } from 'react'
import translations from '../locales/translations'

const Academy = () => {
  const { language } = useLanguage()
  
  const pageContent = useMemo(() => {
    return (translations as any)[language].academy
  }, [language])
  
  const videos = [
    {
      id: 1,
      title: '2025 Yılında Her Ay Milyonlarca Satış Yapan Şirketlerin E-Ticaret Stratejileri',
      description: 'E-ticaret sektöründe başarılı olan şirketlerin 2025 yılında kullandığı stratejiler ve teknikler hakkında detaylı bilgi. Sürdürülebilir büyüme için gerekli tüm yaklaşımlar.',
      youtubeId: 'XJY48q_9GWo',
      duration: '27:42',
      category: 'E-Ticaret'
    },
    {
      id: 2,
      title: '10 Dakikada Öğren: E-Ticaret Reklamlarında Nasıl Kâr Hesaplanır?',
      description: 'E-ticaret işletmeleri için ROAS, ROI, Break-even ROAS, LTV ve net kâr oranı gibi kritik performans metriklerinin hesaplanmasını öğrenin. Google Sheets tablosu üzerinden örnek veriler ile adım adım hesaplamalar gerçekleştirin.',
      youtubeId: 'oTQZNodzc5Q',
      duration: '12:40',
      category: 'Analitik'
    }
  ]

  // Truncate description to 200 characters
  const truncateDescription = (text: string) => {
    return text.length > 200 ? text.substring(0, 200) + '...' : text
  }

  return (
    <div className="pt-16 bg-[#f9f9f9] relative min-h-screen">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)] bg-[size:80px_80px] [mask-image:radial-gradient(ellipse_60%_40%_at_50%_10%,#000_20%,transparent_70%)] opacity-40 pointer-events-none"></div>
      
      {/* Hero Section */}
      <section className="py-24 relative">
        <div className="max-w-[1200px] mx-auto px-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <span className="inline-block text-[13px] font-medium text-[#666] bg-white px-4 py-1.5 rounded-full border border-gray-200 mb-6">
              {pageContent.badge}
            </span>
            <h1 className="text-[28px] md:text-[44px] font-bold text-[#111] leading-tight mb-6">
              {pageContent.title}
            </h1>
            <p className="text-lg md:text-xl text-[#555] max-w-3xl mx-auto mb-8 leading-relaxed">
              {pageContent.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="pb-24 relative">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-sm text-[#666] mb-4">{pageContent.videosSection.badge}</p>
            <h2 className="text-[24px] md:text-[36px] font-bold text-[#111] leading-tight mb-6">
              {pageContent.videosSection.title}
            </h2>
            <p className="text-lg text-[#555] max-w-3xl mx-auto mb-8 leading-relaxed">
              {pageContent.videosSection.description}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((video, index) => (
              <motion.div
                key={video.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
              >
                {/* Video Thumbnail */}
                <div className="relative aspect-video bg-gray-900">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${video.youtubeId}`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                
                {/* Video Info */}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded">
                      {video.category}
                    </span>
                    <span className="text-xs text-[#666]">{video.duration}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-[#111] mb-2">
                    {video.title}
                  </h3>
                  
                  <p className="text-[#555] leading-relaxed text-sm">
                    {truncateDescription(video.description)}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default Academy















